import { BookSize } from '@mixtiles/web-backend-shared'
import type { QuestionProps } from '../../components/FaqSection/consts'

export const DEFAULT_PHOTO_RATIO = 1
export const DEFAULT_COVER_TEXT_KEY = 'photo_book.default_cover_text'
export const MINIMUM_PHOTOS = 24
export const DEFAULT_MAXIMUM_PHOTOS = 150
export const PAGE_TEXT_MAX_LENGTH = 25

// when the user crosses this threshold, the crop will actually start.
// when he is below this threshold, the crop will not start, enabling a user to easily fit the photo to the page
// During first zoom, while the photo already fits the page, we want to ignore this "resistance"
export const CROP_RESISTANCE_PERCENTAGE = 0.8

export const getPhotoBookFAQs = (
  getSizeName: (size: BookSize) => string,
  getPrice: (size: BookSize) => string,
  getDeliveryTime: () => string
): QuestionProps[] => {
  const translateParamsSize: Record<string, string> = {
    v1: getSizeName(BookSize.BOOK_8X8),
    v1_price: getPrice(BookSize.BOOK_8X8),
    v2: getSizeName(BookSize.BOOK_10X10),
    v2_price: getPrice(BookSize.BOOK_10X10),
    v3: getSizeName(BookSize.BOOK_12X12),
    v3_price: getPrice(BookSize.BOOK_12X12),
  }

  const translateParamsDelivery: Record<string, string> = {
    delivery_time: getDeliveryTime(),
  }

  return [
    {
      translateKey: 'photo-books-size',
      question: 'What sizes do Photo Books come in?',
      translateParams: translateParamsSize,
    },
    {
      translateKey: 'photo-books-customize',
      question: 'How can I customize my Photo Book?',
    },
    {
      translateKey: 'photo-books-delivery',
      question: 'How long does it take to receive my Photo Book?',
      translateParams: translateParamsDelivery,
    },
    {
      translateKey: 'photo-books-material',
      question: 'What materials are the books made of?',
    },
    {
      translateKey: 'photo-books-discount',
      question:
        'I received a discount for Mixtiles. Can I apply it to my Photo Book purchase?',
    },
    {
      translateKey: 'photo-books-shipment',
      question: 'What countries do you ship to?',
    },
  ]
}
